import InsuranceSummary from './InsuranceSummary';

export default InsuranceSummary;
